var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BasicModal",
    {
      staticClass: "basic-modal add-video-modal",
      attrs: {
        id: "add-video-modal",
        title: _vm.$t("common.modal.add_video.title")
      },
      on: { ok: _vm.addVideo, cancel: _vm.clear }
    },
    [
      _c("div", { staticClass: "add-video-input-area" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.videoLink,
              expression: "videoLink"
            }
          ],
          attrs: {
            placeholder: _vm.$t("common.modal.add_video.input_placeholder"),
            type: "url"
          },
          domProps: { value: _vm.videoLink },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.videoLink = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--caption typography--color-secondary" },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("common.modal.add_video.message")) + "\n  "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e74d8e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e74d8e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-cards/components/AddVideoModal.vue
// module id = UhI+
// module chunks = 1